import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useHasPermission } from "../../contexts/auth";
import styles from "./settlements.module.css";

export const Settlements = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const canViewStatistics = useHasPermission("settlement.can_view_settlement_statistics");
  const canViewProfitability = useHasPermission("settlement.can_view_profitability");

  const basePath = "/settlements";
  const isStatisticsTab =
    canViewStatistics && location.pathname.includes(`${basePath}/statistics`);
  const isProfitabilityTab =
    canViewProfitability && location.pathname.includes(`${basePath}/profitability`);
  // Tabs are indexed by position, so the profitability tab moves up one
  // when the statistics tab is hidden.
  const profitabilityTabValue = canViewStatistics ? 2 : 1;
  const tabValue = isProfitabilityTab ? profitabilityTabValue : isStatisticsTab ? 1 : 0;

  return (
    <Box className={styles.container}>
      <Tabs value={tabValue}>
        <Tab label={t("Sale summary")} onClick={() => navigate(basePath)} />
        {canViewStatistics && (
          <Tab label={t("Statistics")} onClick={() => navigate(`${basePath}/statistics`)} />
        )}
        {canViewProfitability && (
          <Tab
            label={t("Profitability")}
            onClick={() => navigate(`${basePath}/profitability`)}
          />
        )}
      </Tabs>
      <Box className={styles.content}>
        <Outlet />
      </Box>
    </Box>
  );
};
